import { Injectable, Inject } from '@angular/core';
import { GroupService } from '../odata-services/services/group.service';
import { GridDataService } from './core/griddata.service';
import { NotificationService } from '@progress/kendo-angular-notification';

//import { Sortimentsauswahl } from '../models/sortimente/sortimentsauswahl.model';

@Injectable({
  providedIn: 'root'
})
export class GroupDataService extends GridDataService {
    
  public odataService: GroupService;
  
  
    constructor( @Inject(GroupService)  service: GroupService, @Inject(NotificationService) notificationService?: NotificationService) { 
      super(service,null,notificationService); 
      this.odataService = service;
    }
  
    //public SaveIsZugeordnet(item : Sortimentsauswahl, state: State) : void
   /*  public SaveIsZugeordnet(item : any, state: State) : void
    { 
        this.update(item);
        this.saveChanges(state);
    } */


}
